var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.2055 8.63129C15.8785 9.01496 15.8785 9.98507 15.2055 10.3687L2.00832 17.8929C1.34167 18.273 0.51303 17.7916 0.51303 17.0242L0.513031 1.97586C0.513031 1.20847 1.34167 0.727044 2.00832 1.10712L15.2055 8.63129Z","fill":"#030D21"}));
}

PlayInline.defaultProps = {"width":"16","height":"19","viewBox":"0 0 16 19","fill":"none"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
